var ProductAccess;
(function(ProductAccess) {
    ProductAccess["Core"] = "CORE";
    ProductAccess["Cloud"] = "CLOUD";
    ProductAccess["Enterprise"] = "ENTERPRISE";
    ProductAccess["GuidesOnly"] = "GUIDES_ONLY";
    ProductAccess["HipaaClaims"] = "HIPAA_CLAIMS";
    ProductAccess["HipaaClaimStatus"] = "HIPAA_CLAIM_STATUS";
    ProductAccess["HipaaEligibility"] = "HIPAA_ELIGIBILITY";
})(ProductAccess || (ProductAccess = {}));
var UserExperienceGroup;
(function(UserExperienceGroup) {
    UserExperienceGroup["Clearinghouse"] = "clearinghouse";
    UserExperienceGroup["EdiPlatform"] = "edi-platform";
    UserExperienceGroup["EdiPlatformWithHealthcare"] = "edi-platform-with-healthcare";
    UserExperienceGroup["EdiPlatformWithClaims"] = "edi-platform-with-claims";
    UserExperienceGroup["EligibilityOnly"] = "eligibility-only";
    UserExperienceGroup["GuidesOnly"] = "guides-only";
})(UserExperienceGroup || (UserExperienceGroup = {}));

export { ProductAccess, UserExperienceGroup };
